var _circle, _circle2, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTargetTypeA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 38.5,
    stroke: "#4FC7E4",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 28.5,
    stroke: "#4FC7E4",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2815 93.7313C16.5808 95.2328 17.2299 97.0179 18.7313 97.7185C20.2328 98.4192 22.0179 97.7701 22.7185 96.2687L17.2815 93.7313ZM24.2815 78.7313L17.2815 93.7313L22.7185 96.2687L29.7185 81.2687L24.2815 78.7313Z",
    fill: "#4FC7E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2815 96.2683C77.9823 97.7697 79.7674 98.4187 81.2688 97.718C82.7702 97.0173 83.4192 95.2321 82.7185 93.7307L77.2815 96.2683ZM82.7185 93.7307L75.7177 78.7311L70.2807 81.2687L77.2815 96.2683L82.7185 93.7307Z",
    fill: "#4FC7E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8948 55.952H46.7188L45.5988 60.432H38.6547L46.6868 34.352H53.1508L61.3428 60.432H54.0148L52.8948 55.952ZM51.6468 49.616L50.0148 41.968H49.9188L48.0948 49.616H51.6468Z",
    fill: "#4FC7E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetTypeA);
export default __webpack_public_path__ + "static/media/target-type-A.19001a6e6887cd44f5d460bebb7b6f87.svg";
export { ForwardRef as ReactComponent };